import { OktaAuth } from '@okta/okta-auth-js';
import decode from 'jwt-decode';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

function _toPrimitive(input, hint) {
  if (_typeof$1(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof$1(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var regeneratorRuntime$1 = {exports: {}};

var _typeof = {exports: {}};

(function (module) {
	function _typeof(o) {
	  "@babel/helpers - typeof";

	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (_typeof));

var _typeofExports = _typeof.exports;

(function (module) {
	var _typeof = _typeofExports["default"];
	function _regeneratorRuntime() {
	  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
	    return e;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  var t,
	    e = {},
	    r = Object.prototype,
	    n = r.hasOwnProperty,
	    o = Object.defineProperty || function (t, e, r) {
	      t[e] = r.value;
	    },
	    i = "function" == typeof Symbol ? Symbol : {},
	    a = i.iterator || "@@iterator",
	    c = i.asyncIterator || "@@asyncIterator",
	    u = i.toStringTag || "@@toStringTag";
	  function define(t, e, r) {
	    return Object.defineProperty(t, e, {
	      value: r,
	      enumerable: !0,
	      configurable: !0,
	      writable: !0
	    }), t[e];
	  }
	  try {
	    define({}, "");
	  } catch (t) {
	    define = function define(t, e, r) {
	      return t[e] = r;
	    };
	  }
	  function wrap(t, e, r, n) {
	    var i = e && e.prototype instanceof Generator ? e : Generator,
	      a = Object.create(i.prototype),
	      c = new Context(n || []);
	    return o(a, "_invoke", {
	      value: makeInvokeMethod(t, r, c)
	    }), a;
	  }
	  function tryCatch(t, e, r) {
	    try {
	      return {
	        type: "normal",
	        arg: t.call(e, r)
	      };
	    } catch (t) {
	      return {
	        type: "throw",
	        arg: t
	      };
	    }
	  }
	  e.wrap = wrap;
	  var h = "suspendedStart",
	    l = "suspendedYield",
	    f = "executing",
	    s = "completed",
	    y = {};
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	  var p = {};
	  define(p, a, function () {
	    return this;
	  });
	  var d = Object.getPrototypeOf,
	    v = d && d(d(values([])));
	  v && v !== r && n.call(v, a) && (p = v);
	  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
	  function defineIteratorMethods(t) {
	    ["next", "throw", "return"].forEach(function (e) {
	      define(t, e, function (t) {
	        return this._invoke(e, t);
	      });
	    });
	  }
	  function AsyncIterator(t, e) {
	    function invoke(r, o, i, a) {
	      var c = tryCatch(t[r], t, o);
	      if ("throw" !== c.type) {
	        var u = c.arg,
	          h = u.value;
	        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
	          invoke("next", t, i, a);
	        }, function (t) {
	          invoke("throw", t, i, a);
	        }) : e.resolve(h).then(function (t) {
	          u.value = t, i(u);
	        }, function (t) {
	          return invoke("throw", t, i, a);
	        });
	      }
	      a(c.arg);
	    }
	    var r;
	    o(this, "_invoke", {
	      value: function value(t, n) {
	        function callInvokeWithMethodAndArg() {
	          return new e(function (e, r) {
	            invoke(t, n, e, r);
	          });
	        }
	        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	      }
	    });
	  }
	  function makeInvokeMethod(e, r, n) {
	    var o = h;
	    return function (i, a) {
	      if (o === f) throw new Error("Generator is already running");
	      if (o === s) {
	        if ("throw" === i) throw a;
	        return {
	          value: t,
	          done: !0
	        };
	      }
	      for (n.method = i, n.arg = a;;) {
	        var c = n.delegate;
	        if (c) {
	          var u = maybeInvokeDelegate(c, n);
	          if (u) {
	            if (u === y) continue;
	            return u;
	          }
	        }
	        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
	          if (o === h) throw o = s, n.arg;
	          n.dispatchException(n.arg);
	        } else "return" === n.method && n.abrupt("return", n.arg);
	        o = f;
	        var p = tryCatch(e, r, n);
	        if ("normal" === p.type) {
	          if (o = n.done ? s : l, p.arg === y) continue;
	          return {
	            value: p.arg,
	            done: n.done
	          };
	        }
	        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
	      }
	    };
	  }
	  function maybeInvokeDelegate(e, r) {
	    var n = r.method,
	      o = e.iterator[n];
	    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
	    var i = tryCatch(o, e.iterator, r.arg);
	    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
	    var a = i.arg;
	    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
	  }
	  function pushTryEntry(t) {
	    var e = {
	      tryLoc: t[0]
	    };
	    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
	  }
	  function resetTryEntry(t) {
	    var e = t.completion || {};
	    e.type = "normal", delete e.arg, t.completion = e;
	  }
	  function Context(t) {
	    this.tryEntries = [{
	      tryLoc: "root"
	    }], t.forEach(pushTryEntry, this), this.reset(!0);
	  }
	  function values(e) {
	    if (e || "" === e) {
	      var r = e[a];
	      if (r) return r.call(e);
	      if ("function" == typeof e.next) return e;
	      if (!isNaN(e.length)) {
	        var o = -1,
	          i = function next() {
	            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
	            return next.value = t, next.done = !0, next;
	          };
	        return i.next = i;
	      }
	    }
	    throw new TypeError(_typeof(e) + " is not iterable");
	  }
	  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
	    value: GeneratorFunctionPrototype,
	    configurable: !0
	  }), o(GeneratorFunctionPrototype, "constructor", {
	    value: GeneratorFunction,
	    configurable: !0
	  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
	    var e = "function" == typeof t && t.constructor;
	    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
	  }, e.mark = function (t) {
	    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
	  }, e.awrap = function (t) {
	    return {
	      __await: t
	    };
	  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
	    return this;
	  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
	    void 0 === i && (i = Promise);
	    var a = new AsyncIterator(wrap(t, r, n, o), i);
	    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
	      return t.done ? t.value : a.next();
	    });
	  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
	    return this;
	  }), define(g, "toString", function () {
	    return "[object Generator]";
	  }), e.keys = function (t) {
	    var e = Object(t),
	      r = [];
	    for (var n in e) r.push(n);
	    return r.reverse(), function next() {
	      for (; r.length;) {
	        var t = r.pop();
	        if (t in e) return next.value = t, next.done = !1, next;
	      }
	      return next.done = !0, next;
	    };
	  }, e.values = values, Context.prototype = {
	    constructor: Context,
	    reset: function reset(e) {
	      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
	    },
	    stop: function stop() {
	      this.done = !0;
	      var t = this.tryEntries[0].completion;
	      if ("throw" === t.type) throw t.arg;
	      return this.rval;
	    },
	    dispatchException: function dispatchException(e) {
	      if (this.done) throw e;
	      var r = this;
	      function handle(n, o) {
	        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
	      }
	      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
	        var i = this.tryEntries[o],
	          a = i.completion;
	        if ("root" === i.tryLoc) return handle("end");
	        if (i.tryLoc <= this.prev) {
	          var c = n.call(i, "catchLoc"),
	            u = n.call(i, "finallyLoc");
	          if (c && u) {
	            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
	            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
	          } else if (c) {
	            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
	          } else {
	            if (!u) throw new Error("try statement without catch or finally");
	            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
	          }
	        }
	      }
	    },
	    abrupt: function abrupt(t, e) {
	      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
	        var o = this.tryEntries[r];
	        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
	          var i = o;
	          break;
	        }
	      }
	      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
	      var a = i ? i.completion : {};
	      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
	    },
	    complete: function complete(t, e) {
	      if ("throw" === t.type) throw t.arg;
	      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
	    },
	    finish: function finish(t) {
	      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
	        var r = this.tryEntries[e];
	        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
	      }
	    },
	    "catch": function _catch(t) {
	      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
	        var r = this.tryEntries[e];
	        if (r.tryLoc === t) {
	          var n = r.completion;
	          if ("throw" === n.type) {
	            var o = n.arg;
	            resetTryEntry(r);
	          }
	          return o;
	        }
	      }
	      throw new Error("illegal catch attempt");
	    },
	    delegateYield: function delegateYield(e, r, n) {
	      return this.delegate = {
	        iterator: values(e),
	        resultName: r,
	        nextLoc: n
	      }, "next" === this.method && (this.arg = t), y;
	    }
	  }, e;
	}
	module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (regeneratorRuntime$1));

var regeneratorRuntimeExports = regeneratorRuntime$1.exports;

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntimeExports();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs(regenerator);

function _createClass(Constructor, protoProps, staticProps) {
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var AuthError = /*#__PURE__*/function (_Error) {
  _inherits(AuthError, _Error);
  var _super = _createSuper(AuthError);
  function AuthError(errorType, message) {
    var _this;
    _classCallCheck(this, AuthError);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "errorCode", void 0);
    _this.message = message;
    _this.errorCode = errorType;
    return _this;
  }
  return _createClass(AuthError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  return unsafeStringify(rnds);
}

var setStateSession = function setStateSession(path) {
  var sessionKey = v4();
  window.sessionStorage.setItem(sessionKey, path);
  return sessionKey;
};
var getStateSession = function getStateSession(key) {
  return window.sessionStorage.getItem(key);
};

/**
 * Get the retry count from local storage
 * @example
 * // if no value has yet been set, it will return null, which you can use like:
 * getRetry('myKey') + 1 // results in 1
 * @returns The retry count (defaults to `null` if not set)
 */
var getRetry = function getRetry(key) {
  return window.localStorage.getItem(key);
};
var setRetry = function setRetry(key, count) {
  window.localStorage.setItem(key, count.toString());
};
var removeRetry = function removeRetry(key) {
  window.localStorage.removeItem(key);
};
var removeStateSession = function removeStateSession(key) {
  return window.sessionStorage.removeItem(key);
};
var parseState = function parseState(url) {
  var stateValue;
  var stateIndex = url.indexOf('state');
  if (stateIndex > -1) {
    var subState = url.substring(stateIndex, url.length);
    var equalIndex = subState.indexOf('=');
    var ampIndex = subState.indexOf('&');
    if (ampIndex > -1) {
      stateValue = subState.substring(equalIndex + 1, ampIndex);
    } else {
      stateValue = subState.substring(equalIndex + 1, subState.length);
    }
  }
  return stateValue;
};
var getRedirectUri = function getRedirectUri() {
  var baseUri = document.baseURI;
  if (!baseUri) {
    var baseNode = document.querySelector('base');
    if (baseNode) {
      baseUri = baseNode.getAttribute('href');
    }
  }
  var result = baseUri || "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname);

  /**
   * ie's document.baseURI is undefined, so if the base element's value
   * is a pathname (like for online sites), it will be missing the
   * protocol and host - stuff it in if it is not specified so we
   * end up with a valid redirect uri
   */
  if (!result.match(/^http/i)) {
    result = result.startsWith('/') ? result : "/".concat(result);
    result = "".concat(window.location.protocol, "//").concat(window.location.host).concat(result);
  }
  var hashIndex = result.indexOf('#');
  if (hashIndex !== -1) {
    result = result.substring(0, hashIndex);
  }
  var queryIndex = result.indexOf('?');
  if (queryIndex !== -1) {
    result = result.substring(0, queryIndex);
  }
  return result.toLowerCase();
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var accessTokenKey = "accessToken";
var idTokenKey = "idToken";
function createClient(commonConfig, overrides, accessToken, idToken) {
  var badConfigOptions = [];
  if (!commonConfig) {
    throw new AuthError('missing_configuration', 'Missing required oAuth client configuration');
  }
  var config = _objectSpread(_objectSpread(_objectSpread({}, {
    redirectUri: getRedirectUri(),
    connection: 'chradfs',
    scopes: ['openid', 'profile', 'email'],
    responseType: 'code',
    audience: commonConfig.oAuthAudience,
    clientId: commonConfig.oAuthClientId,
    domain: commonConfig.oAuthDomain,
    tokenStorageType: 'memory'
  }), commonConfig), overrides);

  // do validation of config blob
  if (!config.clientId) {
    badConfigOptions.push('No oAuth client id specified in configuration');
  }
  if (!config.domain) {
    badConfigOptions.push('No oAuth domain specified in configuration');
  }
  if (!config.responseType) {
    badConfigOptions.push('No oAuth response type specified in configuration');
  }
  if (!config.redirectUri) {
    badConfigOptions.push('No oAuth redirect uri specified in configuration');
  }
  if (!config.audience) {
    badConfigOptions.push('No oAuth audience specified in configuration');
  }
  if (!config.scopes) {
    badConfigOptions.push('No oAuth scopes specified in configuration');
  }
  if (badConfigOptions.length > 0) {
    throw new AuthError('missing_configuration', badConfigOptions.join(', '));
  }
  var authRetryKey = "".concat(commonConfig.oAuthClientId, "-auth-retry");
  var entry = getRetry(authRetryKey);
  if (!entry) {
    setRetry(authRetryKey, 0);
  }

  // new up the thing we will use internally
  var oktaAuthClient = new OktaAuth({
    scopes: config.scopes,
    issuer: config.domain,
    clientId: config.clientId,
    redirectUri: config.redirectUri,
    tokenManager: {
      storage: config.tokenStorageType,
      expireEarlySeconds: 120,
      autoRenew: true
    },
    responseType: config.responseType,
    pkce: true
  });
  if (accessToken || idToken) {
    try {
      oktaAuthClient.tokenManager.setTokens({
        accessToken: accessToken,
        idToken: idToken
      });
    } catch (err) {
      throw new AuthError(err.errorCode, err.message);
    }
  }
  var isClientRunning = false;
  function startClient() {
    return _startClient.apply(this, arguments);
  }
  function _startClient() {
    _startClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (isClientRunning) {
              _context9.next = 4;
              break;
            }
            isClientRunning = true;
            _context9.next = 4;
            return oktaAuthClient.start();
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _startClient.apply(this, arguments);
  }
  if (!oktaAuthClient.token.isLoginRedirect()) {
    // if we are not in the middle of a login redirect, then we should start the token manager
    // this will clean up expired tokens, etc
    startClient();
  }

  // declare anything that needs to persist w/in scope (any stateful stuff)]

  // listen for when a token is about to expire and try to renew it
  // "`expired` - Fired before a token is set to expire (using `expireEarlySeconds` option, 30 seconds by default)."
  oktaAuthClient.tokenManager.on('expired', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return oktaAuthClient.tokenManager.renew(key);
          case 3:
            _context.next = 10;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            _context.next = 9;
            return client.login();
          case 9:
            throw new AuthError(_context.t0.errorCode, _context.t0.message);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  var getAccessToken = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var token;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return oktaAuthClient.tokenManager.get(accessTokenKey);
          case 3:
            token = _context2.sent;
            return _context2.abrupt("return", token.accessToken);
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            throw new AuthError(_context2.t0.errorCode, _context2.t0.message);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function getAccessToken() {
      return _ref2.apply(this, arguments);
    };
  }();
  var getIdentityToken = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var token;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return oktaAuthClient.tokenManager.get(idTokenKey);
          case 3:
            token = _context3.sent;
            return _context3.abrupt("return", token.idToken);
          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            throw new AuthError(_context3.t0.errorCode, _context3.t0.message);
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return function getIdentityToken() {
      return _ref3.apply(this, arguments);
    };
  }();
  var client = {
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(queryParams) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (queryParams.post_logout_redirect_uri) {
                _context4.next = 2;
                break;
              }
              throw new Error('Please specify queryParams.post_logout_redirect_uri so we can send the user somewhere after successfully logging out');
            case 2:
              removeRetry(authRetryKey);
              _context4.next = 5;
              return oktaAuthClient.closeSession();
            case 5:
              _context4.next = 7;
              return oktaAuthClient.signOut({
                postLogoutRedirectUri: queryParams.post_logout_redirect_uri,
                revokeAccessToken: false,
                revokeRefreshToken: false
              });
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function logout(_x2) {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    login: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var url, state;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = window.location.href.replace(new RegExp(document.baseURI, 'gi'), '') || document.baseURI;
              state = setStateSession(url);
              _context5.next = 4;
              return oktaAuthClient.token.getWithRedirect({
                state: state
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function login() {
        return _login.apply(this, arguments);
      }
      return login;
    }(),
    getIdentity: function () {
      var _getIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var token;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return oktaAuthClient.tokenManager.get(idTokenKey);
            case 3:
              token = _context6.sent;
              return _context6.abrupt("return", decode(token.idToken));
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", null);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 7]]);
      }));
      function getIdentity() {
        return _getIdentity.apply(this, arguments);
      }
      return getIdentity;
    }(),
    getAccessToken: getAccessToken,
    getIdentityToken: getIdentityToken,
    ensureAuthed: function () {
      var _ensureAuthed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var state, params, authCodeIsPresentInParams, accessTokenObject, idTokenObject, tokensWereFound, sessionExists, session, refreshedTokens, tokens;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // ensureAuthed is typically invoked on page load
              // (ex: apps from the template invoke this in their index.tsx -> bootStrapAppAsync -> authClient.ensureAuthed())
              //
              // scenarios:
              // - tokens exist and are not expired (1a): do nothing (ex: user is currently using or very recently was using the app)
              // - tokens are expired and a session is active (1b): refresh tokens using the session (no redirect) (ex: app was open long enough that tokens expired but session remained active?)
              // - tokens do not exist or are expired and no session is active (1c): redirect to Okta to login (ex: on first visit to an app)
              // - auth code is in href (2): parse the auth code and get tokens (ex: was just redirected from Okta)
              // - error occurred: redirect to Okta to login (attempted up to 3 times, then give up)
              state = parseState(window.location.href);
              params = new URLSearchParams(window.location.search);
              authCodeIsPresentInParams = params.has('code');
              if (authCodeIsPresentInParams) {
                _context7.next = 46;
                break;
              }
              setRetry(authRetryKey, Number(getRetry(authRetryKey)) + 1);
              _context7.prev = 5;
              _context7.next = 8;
              return oktaAuthClient.tokenManager.get(accessTokenKey);
            case 8:
              accessTokenObject = _context7.sent;
              _context7.next = 11;
              return oktaAuthClient.tokenManager.get(idTokenKey);
            case 11:
              idTokenObject = _context7.sent;
              tokensWereFound = accessTokenObject && idTokenObject && !oktaAuthClient.tokenManager.hasExpired(accessTokenObject) && !oktaAuthClient.tokenManager.hasExpired(idTokenObject);
              if (!tokensWereFound) {
                _context7.next = 18;
                break;
              }
              // SCENARIO 1a: already logged in

              // reset the retry count since we are logged in
              removeRetry(authRetryKey);

              // return the tokens we found in storage
              return _context7.abrupt("return", {
                accessToken: accessTokenObject.accessToken,
                identityToken: idTokenObject.idToken,
                identity: idTokenObject.claims
              });
            case 18:
              _context7.next = 20;
              return oktaAuthClient.session.exists();
            case 20:
              sessionExists = _context7.sent;
              if (!sessionExists) {
                _context7.next = 32;
                break;
              }
              _context7.next = 24;
              return oktaAuthClient.session.get();
            case 24:
              session = _context7.sent;
              if (!(session.status != "ACTIVE")) {
                _context7.next = 27;
                break;
              }
              throw new AuthError('inactive_session', "session was ".concat(session.status));
            case 27:
              _context7.next = 29;
              return refreshTokensWithSession(oktaAuthClient, config, state, session);
            case 29:
              refreshedTokens = _context7.sent;
              // reset the retry count since we are now logged in
              removeRetry(authRetryKey);

              // return the tokens we got from refreshing
              return _context7.abrupt("return", refreshedTokens);
            case 32:
              throw new AuthError('inactive_session', "session does not exist.");
            case 33:
              _context7.next = 44;
              break;
            case 35:
              _context7.prev = 35;
              _context7.t0 = _context7["catch"](5);
              if (!(getRetry(authRetryKey) >= '3')) {
                _context7.next = 41;
                break;
              }
              // give up after 3 retries

              // reset the retry count and clear any stored tokens to give user a fresh start next time
              removeRetry(authRetryKey);
              oktaAuthClient.tokenManager.clear();
              throw new AuthError(_context7.t0.errorCode, _context7.t0.message);
            case 41:
              _context7.next = 43;
              return client.login();
            case 43:
              throw new AuthError(_context7.t0.errorCode, _context7.t0.message);
            case 44:
              _context7.next = 67;
              break;
            case 46:
              // auth code is in href
              setRetry(authRetryKey, Number(getRetry(authRetryKey)) + 1);
              _context7.prev = 47;
              _context7.next = 50;
              return parseFromUrl(oktaAuthClient, state, authRetryKey);
            case 50:
              tokens = _context7.sent;
              _context7.next = 53;
              return startClient();
            case 53:
              return _context7.abrupt("return", tokens);
            case 56:
              _context7.prev = 56;
              _context7.t1 = _context7["catch"](47);
              if (!(getRetry(authRetryKey) >= '3')) {
                _context7.next = 62;
                break;
              }
              removeRetry(authRetryKey);
              oktaAuthClient.tokenManager.clear();
              throw new AuthError(_context7.t1.errorCode, _context7.t1.message);
            case 62:
              if (!(_context7.t1.message.indexOf("The JWT was issued in the future") === -1)) {
                _context7.next = 66;
                break;
              }
              _context7.next = 65;
              return client.login();
            case 65:
              throw new AuthError(_context7.t1.errorCode, _context7.t1.message);
            case 66:
              throw new AuthError(_context7.t1.errorCode, _context7.t1.message);
            case 67:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[5, 35], [47, 56]]);
      }));
      function ensureAuthed() {
        return _ensureAuthed.apply(this, arguments);
      }
      return ensureAuthed;
    }(),
    onRenewed: function onRenewed(callback) {
      oktaAuthClient.tokenManager.on('renewed', /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(key, freshToken, oldToken) {
          var _accessToken, identityToken;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                if (!(key === accessTokenKey && freshToken.accessToken !== oldToken.accessToken || key === idTokenKey && freshToken.idToken !== oldToken.idToken)) {
                  _context8.next = 18;
                  break;
                }
                if (!(key === accessTokenKey)) {
                  _context8.next = 5;
                  break;
                }
                _context8.t0 = freshToken.accessToken;
                _context8.next = 8;
                break;
              case 5:
                _context8.next = 7;
                return client.getAccessToken();
              case 7:
                _context8.t0 = _context8.sent;
              case 8:
                _accessToken = _context8.t0;
                if (!(key === idTokenKey)) {
                  _context8.next = 13;
                  break;
                }
                _context8.t1 = freshToken.idToken;
                _context8.next = 16;
                break;
              case 13:
                _context8.next = 15;
                return client.getIdentityToken();
              case 15:
                _context8.t1 = _context8.sent;
              case 16:
                identityToken = _context8.t1;
                callback(_accessToken, identityToken);
              case 18:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        return function (_x3, _x4, _x5) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    getUser: function getUser() {
      return oktaAuthClient.getUser();
    }
  };
  return client;
}
function parseFromUrl(_x6, _x7, _x8) {
  return _parseFromUrl.apply(this, arguments);
}
/** Get new tokens using the active session without bothering the user with a redirect. */
function _parseFromUrl() {
  _parseFromUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(oktaAuthClient, state, authRetryKey) {
    var tokenResponse, accessToken, idToken, decodedState, sessionState;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return oktaAuthClient.token.parseFromUrl();
        case 2:
          tokenResponse = _context10.sent;
          accessToken = tokenResponse.tokens.accessToken;
          idToken = tokenResponse.tokens.idToken;
          oktaAuthClient.tokenManager.setTokens(tokenResponse.tokens);
          if (state) {
            decodedState = decodeURIComponent(state);
            sessionState = getStateSession(decodedState);
            removeStateSession(decodedState);
            if (sessionState) {
              window.history.replaceState(null, null, sessionState);
            }
          }

          // reset the retry count since we are logged in
          removeRetry(authRetryKey);
          return _context10.abrupt("return", {
            accessToken: accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken,
            identityToken: idToken === null || idToken === void 0 ? void 0 : idToken.idToken,
            identity: idToken === null || idToken === void 0 ? void 0 : idToken.claims
          });
        case 9:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _parseFromUrl.apply(this, arguments);
}
function refreshTokensWithSession(_x9, _x10, _x11, _x12) {
  return _refreshTokensWithSession.apply(this, arguments);
}
/**
 * @deprecated Import from root instead.
 * @example
 * // deprecated:
 * import { type ChrAuthClient, type ChrDecodedJwt } from '@chr/common-web-ui-authentication/authClient';
 * import { type ChrAuthClient, type ChrDecodedJwt } from '@chr/common-web-ui-authentication/authClientTypes';
 *
 * // recommended:
 * import { type ChrAuthClient, type ChrDecodedJwt } from '@chr/common-web-ui-authentication';
 */
function _refreshTokensWithSession() {
  _refreshTokensWithSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(oktaAuthClient, config, state, session) {
    var tokenResponse;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return oktaAuthClient.token.getWithoutPrompt({
            scopes: config.scopes,
            responseType: ['token', 'id_token'],
            state: state ? state : undefined,
            sessionToken: session.id // TODO the SessionObject type does not contain an `id` property... are the types wrong, or will this always be undefined?
          });
        case 2:
          tokenResponse = _context11.sent;
          oktaAuthClient.tokenManager.setTokens(tokenResponse.tokens);
          return _context11.abrupt("return", {
            accessToken: tokenResponse.tokens.accessToken.accessToken,
            identityToken: tokenResponse.tokens.idToken.idToken,
            identity: tokenResponse.tokens.idToken.claims
          });
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _refreshTokensWithSession.apply(this, arguments);
}

export { createClient, parseState };
//# sourceMappingURL=index.es.js.map
